/**
 * Cookie piece count for tax rules (6+ pieces = no HST).
 * Stuffed cookie products can be single, half dozen (6), or dozen (12);
 * product name is parsed so Tammy's menu names work without code changes.
 */
export function getTotalCookiesFromName(productName: string): number {
  const lower = (productName || '').toLowerCase();
  if (/\bhalf\s*dozen\b|\b6\s*cookie|\b6\s*pack\b/.test(lower)) return 6;
  if (/\bdozen\b|\b12\s*cookie|\b12\s*pack\b/.test(lower)) return 12;
  return 1;
}
